import React, { createContext, useState, useEffect, useContext } from 'react';

// Create the AuthContext
const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

// Decode a JWT payload without verifying the signature (the backend still
// verifies it on every request) - used here purely to check expiry client-side.
const parseJwt = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
};

const isTokenValid = (token) => {
  const payload = parseJwt(token);
  return !!payload && !!payload.exp && payload.exp * 1000 > Date.now();
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userEmail, setUserEmail] = useState(null);
  const [loading, setLoading] = useState(true); // Added loading state

  useEffect(() => {
    const token = localStorage.getItem('token');

    if (token && isTokenValid(token)) {
      setIsAuthenticated(true);
      setUserEmail(parseJwt(token)?.email || null);
    } else {
      if (token) localStorage.removeItem('token'); // clear stale/expired token
      setIsAuthenticated(false);
      setUserEmail(null);
    }
    setLoading(false); // Ensure loading is false after token check
  }, []);

  const login = (token) => {
    localStorage.setItem('token', token);
    setIsAuthenticated(true);
    setUserEmail(parseJwt(token)?.email || null);
  };

  const logout = () => {
    localStorage.removeItem('token');
    setIsAuthenticated(false);
    setUserEmail(null);
  };

  if (loading) {
    // Render nothing or a loader until loading completes
    return <div>Loading...</div>;
  }

  return (
    <AuthContext.Provider value={{ isAuthenticated, userEmail, login, logout }}>
      {children}
    </AuthContext.Provider>
  );

};
